import { render, staticRenderFns } from "./yxsxssjlist.vue?vue&type=template&id=659c5c60&scoped=true"
import script from "./yxsxssjlist.vue?vue&type=script&lang=js"
export * from "./yxsxssjlist.vue?vue&type=script&lang=js"
import style0 from "./yxsxssjlist.vue?vue&type=style&index=0&id=659c5c60&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659c5c60",
  null
  
)

export default component.exports